<div *ngIf="loadingChartAccounts" class="text-center modal-body">
  <span class="loading-spiner spinner-form-left"></span>
</div>

<div class="alert alert-danger" *ngIf="chartAccounts.length === 0">
  <i class="fa fa-exclamation-triangle"></i> {{ 'ACCOUNTS_NOT_FOUND' | translate }}
  <button type="button" class="btn btn-xs" data-dismiss="modal">
    <i class="fa fa-plus"></i> {{ 'ADD_ACCOUNT' | translate }}
  </button>
</div>

<div *ngIf="chartAccounts.length > 0">
  <div class="form-group">
    <label class="col-md-3 control-label">
      {{ 'INCOME_ACCOUNT' | translate }}
    </label>
    <div class="col-md-6">
      <input
        type="text"
        class="select form-control"
        placeholder="{{ 'SELECT' | translate }} ..."
        matInput
        [formControl]="incomeAccountControl"
        [matAutocomplete]="autoIncome"
        (ngModelChange)="validateInputs()"
      />
      <mat-autocomplete autoActiveFirstOption #autoIncome="matAutocomplete">
        <mat-option
          *ngFor="let option of filteredIncomeAccounts | async"
          [value]="option.code + ' ' + option.name"
          (onSelectionChange)="incomeSelected(option.id)"
        >
          {{ option.code }} {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="form-group">
    <label class="col-md-3 control-label">
      {{ 'EXPENSE_ACCOUNT' | translate }}
    </label>
    <div class="col-md-6">
      <input
        type="text"
        class="select form-control"
        placeholder="{{ 'SELECT' | translate }} ..."
        matInput
        [formControl]="expenseAccountControl"
        [matAutocomplete]="autoExpense"
        (ngModelChange)="validateInputs()"
      />
      <mat-autocomplete autoActiveFirstOption #autoExpense="matAutocomplete">
        <mat-option
          *ngFor="let option of filteredExpenseAccounts | async"
          [value]="option.code + ' ' + option.name"
          (onSelectionChange)="expenseSelected(option.id)"
        >
          {{ option.code }} {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </div>
  </div>
  <div class="form-actions no-wrap">
    <div class="alertalert-danger alert-md pull-left text-danger" *ngIf="invalidChartAccounts">
      <i class="fa fa-exclamation-triangle"></i> {{ 'REQUIRED_ONE_OPTION' | translate }}
    </div>
    <span *ngIf="sendingChartAccounts" class="loading-spiner spinner-form-left"></span>

    <!-- Apply-->
    <button
      type="button"
      class="btn btn-lg btn-primary"
      [disabled]="sendingChartAccounts || invalidChartAccounts"
      (click)="applyChartAccounts()"
    >
      <i class="fa fa-save"></i> {{ 'APPLY_CHANGES' | translate }}
    </button>
    <!-- Cancel -->
    <button type="button" class="btn btn-lg" (click)="cancelChartAccounts()">
      <i class="fa fa-undo"></i> {{ 'CANCEL' | translate }}
    </button>
  </div>
</div>
